import table from './table';

const deLocale = { table } as const;

export default deLocale;
